import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import { formatDateDataGrid } from "src/utils/format-date"
import { DATE_FORMAT_SHOW } from "src/utils/constants"


import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterPrecosCalculadosConversibilidadeTable = (props) => {
    const datalakeService = new DatalakeService()

    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({
        count: 0,
        next: null,
        previous: null
    })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .catch(props.callbackError)
            .finally(() => props.loading(false))
    }


    const updateRow = async (newRow) => {
        const {
            ID,
            RendaFixaCaracteristicasID,
            DataReferencia,
            Indexador,
            SpreadCredito,
            TaxaJuros,
            IndexadorCorrecaoPercentual,
            ConversaoFacultativa,
            ConversaoMandatoria,
            DataInicioConversao,
            DataFimConversao,
            Ticker,
            DataInicioPreco,
            PrecoConversao,
            PremioConversao,
            PrecoAcao,
            DataCotacao,
            VolatilidadeAcao,
            P_up,
            P_down,
            NumeroPassos,
            TaxaMTM,
            PUMTM,
            PUPAR,
            PercentualPUPAR,
            Duration,
            DurationAno,
            PremioConversibilidade,
            SpreadConversibilidade,
            LOGERRO
        } = newRow

        const body = {
            RendaFixaCaracteristicasID,
            DataReferencia,
            Indexador,
            SpreadCredito,
            TaxaJuros,
            IndexadorCorrecaoPercentual,
            ConversaoFacultativa,
            ConversaoMandatoria,
            DataInicioConversao,
            DataFimConversao,
            Ticker,
            DataInicioPreco,
            PrecoConversao,
            PremioConversao,
            PrecoAcao,
            DataCotacao,
            VolatilidadeAcao,
            P_up,
            P_down,
            NumeroPassos,
            TaxaMTM,
            PUMTM,
            PUPAR,
            PercentualPUPAR,
            Duration,
            DurationAno,
            PremioConversibilidade,
            SpreadConversibilidade,
            LOGERRO
        }

        props.loading(true)

        return datalakeService
            .updateTableEndpoint(props.endpoint, ID, body)
            .catch((err) => {
                props.loading(false)
                throw err
            })
            .finally(() => props.loading(false))
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService
            .loadPaginationEndpoint(props.endpoint, query, limit, offset)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService
            .paginate(endpoint)
            .then((response) => {
                const { results, count, next, previous } = response.body
                const list = results.map((obj) => ({ ...obj, id: obj.ID }))

                setPagination({ count, next, previous })
                setData(list)
            })
            .finally(() => props.loading(false))
    }

    const columns = [
        { field: 'ID', headerName: '#', minWidth: 80, disableColumnMenu: true, disableFilter: true },

        { field: 'RendaFixaCaracteristicasID', headerName: 'RendaFixaCaracteristicasID', minWidth: 220, editable: true, typeComponent: 'number' },

        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            minWidth: 150,
            editable: true,
            typeComponent: 'date',
            renderCell: (params) => params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        { field: 'Indexador', headerName: 'Indexador', minWidth: 120, editable: true },
        { field: 'SpreadCredito', headerName: 'SpreadCredito', minWidth: 180, editable: true, typeComponent: 'number' },
        { field: 'TaxaJuros', headerName: 'TaxaJuros', minWidth: 120, editable: true, typeComponent: 'number' },
        { field: 'IndexadorCorrecaoPercentual', headerName: 'IndexadorCorrecaoPercentual', minWidth: 120, editable: true, typeComponent: 'number'  },
        { field: 'ConversaoFacultativa', headerName: 'ConversaoFacultativa', minWidth: 180, editable: true, typeComponent: 'number' },
        { field: 'ConversaoMandatoria', headerName: 'ConversaoMandatoria', minWidth: 180, editable: true, typeComponent: 'number' },
        { field: 'DataInicioConversao', headerName: 'DataInicioConversao', minWidth: 200, editable: true },
        { field: 'DataFimConversao', headerName: 'DataFimConversao', minWidth: 200, editable: true },
        { field: 'Ticker', headerName: 'Ticker', minWidth: 120, editable: true },
        { field: 'DataInicioPreco', headerName: 'DataInicioPreco', minWidth: 200, editable: true },
        { field: 'PrecoConversao', headerName: 'PrecoConversao', minWidth: 180, editable: true },
        { field: 'PremioConversao', headerName: 'PremioConversao', minWidth: 180, editable: true },
        { field: 'PrecoAcao', headerName: 'PrecoAcao', minWidth: 150, editable: true, typeComponent: 'number' },
        {
            field: 'DataCotacao',
            headerName: 'DataCotacao',
            minWidth: 150,
            typeComponent: 'date',
            editable: true,
            renderCell: (params) => params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
        },
        { field: 'VolatilidadeAcao', headerName: 'VolatilidadeAcao', minWidth: 180, editable: true, typeComponent: 'number' },
        { field: 'P_up', headerName: 'P_up', minWidth: 120, editable: true, typeComponent: 'number' },
        { field: 'P_down', headerName: 'P_down', minWidth: 120, editable: true, typeComponent: 'number' },
        { field: 'NumeroPassos', headerName: 'NumeroPassos', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'TaxaMTM', headerName: 'TaxaMTM', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'PUMTM', headerName: 'PUMTM', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'PUPAR', headerName: 'PUPAR', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'PercentualPUPAR', headerName: 'PercentualPUPAR', minWidth: 200, editable: true, typeComponent: 'number' },
        { field: 'Duration', headerName: 'Duration', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'DurationAno', headerName: 'DurationAno', minWidth: 150, editable: true, typeComponent: 'number' },
        { field: 'PremioConversibilidade', headerName: 'PremioConversibilidade', minWidth: 220, editable: true, typeComponent: 'number' },
        { field: 'SpreadConversibilidade', headerName: 'SpreadConversibilidade', minWidth: 220, editable: true, typeComponent: 'number' },
        { field: 'LOGERRO', headerName: 'LOGERRO', minWidth: 250, editable: true },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            minWidth: 150,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            minWidth: 150,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <ParameterPaginationTable
            columns={columns}
            data={data}
            setData={setData}
            updateRow={updateRow}
            pagination={pagination}
            onChangePage={changePage}
            filterFunction={onFilter}
            customFilter={true}
            useDeleteButton={false}
        />
    )
}

ParameterPrecosCalculadosConversibilidadeTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterPrecosCalculadosConversibilidadeTable
